import { useQueries } from "@tanstack/react-query";
import React from "react";
import { getBusinessTier, getTiers } from "src/api/settings";
import CustomModal from "src/components/CustomModal";
import UpgradeToTier2 from "src/components/modals/UpgradeToTier2";
import { Button } from "src/components/ui/button";
import withPermissionWrapper from "src/hooks/withPermissionWrapper";
import { cn, renderCurrency } from "src/lib/utils";
import { useAuth } from "src/providers/AuthProvider";

const AccountTier = () => {
	const [{ data: rawTiers }, { data: rawBusinessTier }] = useQueries({
		queries: [
			{
				queryKey: ["account-tiers"],
				queryFn: getTiers,
				suspense: true,
			},
			{
				queryKey: ["account-tiers", "business"],
				queryFn: getBusinessTier,
				suspense: true,
			},
		],
	});

	const tiers = rawTiers?.data;
	const businessTier = rawBusinessTier?.data;

	return (
		<div className="tw-max-w-[600px] tw-mx-auto grid">
			<Tier active tier={businessTier} display />
			<div className="tw-gap-4 tw-grid tw-mt-7">
				<div className="tw-text-center">
					<p className="tw-text-xl tw-text-green tw-font-bold">KYC Level Benefit</p>
					<p className="tw-text-[#333333] tw-text-sm">The higher the level, the higher the transaction limit</p>
				</div>
				{tiers?.map((tier, index) => (
					<Tier tier={tier} key={index} display={businessTier?.tier < tier.tier} />
				))}
			</div>
			<UpgradeTier businessTier={businessTier.tier} />
		</div>
	);
};

const Comp = withPermissionWrapper(AccountTier, "view_business_tier");
export default Comp;

const Tier = ({ active, tier, display }) => {
	if (!display) return null;

	return (
		<div className={cn("tw-rounded-lg tw-px-[35px] tw-py-[20px] tw-grid tw-gap-1.5", active ? "tw-bg-green" : "tw-bg-white")}>
			<div className="tw-flex tw-items-center tw-justify-between">
				<p className={cn("tw-text-[22px] tw-font-semibold", active ? "tw-text-white" : "tw-text-green")}>Tier {tier?.tier}</p>
				{active && (
					<span className="tw-bg-white tw-px-2.5 tw-tracking-wider tw-py-1 tw-rounded-3xl tw-text-green tw-font-medium tw-text-sm">
						Current
					</span>
				)}
			</div>
			<div className="tw-grid tw-grid-cols-2">
				<InfoColumn
					label="Daily Transaction Limit"
					labelClassName={cn(active ? "tw-text-white" : "tw-text-[#333333]")}
					className={cn(active ? "tw-text-white" : "tw-text-primary")}
				>
					{renderCurrency(tier?.daily_limit)}
				</InfoColumn>
				<InfoColumn
					label="Maximum Transaction Limit"
					labelClassName={cn(active ? "tw-text-white" : "tw-text-[#333333]")}
					className={cn(active ? "tw-text-white" : "tw-text-primary")}
				>
					{renderCurrency(tier?.max_limit)}
				</InfoColumn>
			</div>
			<InfoColumn label="Requirements" labelClassName={cn(active ? "tw-text-white" : "tw-text-[#333333]")}>
				<ul className={cn("tw-gap-4 tw-list-disc tw-list-inside tw-flex tw-items-center tw-text-[15px]", active && "tw-text-white")}>
					{tier?.requirements?.map((req, index) => (
						<li key={index}>{req}</li>
					))}
				</ul>
			</InfoColumn>
		</div>
	);
};

const InfoColumn = ({ label, children, className, containerClassName, labelClassName, active }) => {
	return (
		<div className={cn("", containerClassName)}>
			<p className={cn("tw-text-sm", labelClassName)}>{label}</p>
			<div className={cn("tw-font-bold tw-text-[22px]", className)}>{children}</div>
		</div>
	);
};

const UpgradeTier = ({ businessTier }) => {
	const { user } = useAuth();

	if (!user?.bvn_verified)
		return (
			<CustomModal title="Upgrade to Tier 2" trigger={<Button className="tw-w-full tw-mt-4">Upgrade to Tier 2</Button>}>
				<UpgradeToTier2 />
			</CustomModal>
		);

	return null;
};
